import React from 'react';
import { createRoot } from 'react-dom/client';
import DOMPurify from 'dompurify';

import Slide1 from './slides/slide1';
import Slide2 from './slides/slide2';
import Slide3 from './slides/slide3';
import Slide4 from './slides/slide4';
import Slide5 from './slides/slide5';

'use strict';
var serverData;
const serverDataURL = document.getElementById('preservation-calculator').getAttribute('data-apiURL');
const journeyParam = document.getElementById('preservation-calculator').getAttribute('data-journey');


class App extends React.Component {
    constructor(props) {
        super(props);  
        this.custScrollTo = this.custScrollTo.bind(this);
        this.mainNavOffsetHandler = this.mainNavOffsetHandler.bind(this);
        this.MOBILE_NAV_BREAKPOINT = 768;
        this.isMobile = window.matchMedia("(max-width: 767px)").matches; 
        this.journey = parseInt(journeyParam) || 1; // 1 for exit journey (default), 2 for savings component journey
        this.state = {           
            step: 1,
            loading: true,
            data: serverData,
            goToSlide4: false,
            formValues: {
                currentAge: 0,
                retireAge: 0,
                gender: 0,
                leavingReason: 0,
                currentInvestment: 0,
                vestedInvestment: 0,
                savingsInvestment: 0
            }
        };
    }

    componentDidMount() {

        // begin at first step on reload
        this.toggleSlide(1);

        this.isMobile = window.matchMedia("(max-width: 767px)").matches; 

        // get data & set loading state to false on success
        $.getJSON(serverDataURL)          
            .done((data) => {
                this.setState({
                    data: data,
                    loading: false
                });
                window.scroll(0, this.isMobile ? 77 : 130);
            })
            .fail((jqxhr, textStatus, error) => {
                var err = textStatus + ", " + error;
                console.log("Server data request failed: " + err);

                $.getJSON('data/fakeServerData.json')                 
                    .done((data) => {
                        this.setState({
                            data: data,
                            loading: false
                        });
                        window.scroll(0, this.isMobile ? 77 : 130);
                    })
                    .fail(function (jqxhr, textStatus, error) {
                        var err = textStatus + ", " + error;
                        console.log("Fallback data request failed: " + err);
                    });
            });
        
        window.dataLayer = window.dataLayer || [];
        window.addEventListener('scroll', this.mainNavOffsetHandler);
    }

    recordAnalytics(e) {

        gtag('event', e.currentTarget.getAttribute('data-analytics-action'), {
            'event_category': e.currentTarget.getAttribute('data-analytics-category'),
            'event_label': e.currentTarget.getAttribute('data-analytics-label'),
        });
    }

    toggleSlide(slideNum, isBulletNav = false) {        

        // do nothing if slide # not yet unlocked AND is bullet nav 
        if (slideNum > this.state.step && isBulletNav) {
            return
        }

        switch (slideNum) {
            case 1:
                this.setStepHandler(1);
                window.location.href = '#step-1';
                break;
            case 2:
                this.setStepHandler(2);
                window.location.href = '#step-2';
                break;
            case 3:
                this.setStepHandler(3);
                window.location.href = this.journey === 2 ? '#step-2' : '#step-3';               
                break;
            case 4:
                this.setStepHandler(4);
                window.location.href = this.journey === 2 ? '#step-3' : '#step-4'                
                break;
            case 5.1:
                this.setStepHandler(5);
                window.location.href = this.journey === 2 ? '#step-4-Transfer' : '#step-5-Transfer';
                break;
            case 5.2:
                this.setStepHandler(5);
                window.location.href = this.journey === 2 ? '#step-4-Remain' : '#step-5-Remain';               
                break;
            case 5.3:
                this.setStepHandler(5);
                window.location.href = this.journey === 2 ? '#step-4-Withdraw' : '#step-5-Withdraw';              
                break;
            default:
                break;
        }

        // if usabilla survey active, send virtual pageview
        try {
            window.usabilla_live("virtualPageView");
        }
        catch (err) {
            console.log('Unable to trigger usabilla virtual pageview');
        }

        gtag('event', 'page_view', {
            page_title: 'Preservation tool: ' + window.location.hash.slice(1),
            page_path: window.location.href
        });

    }
    goToSlide4() {
        this.setState({ goToSlide4: true, step: 4 })
        window.location.href = '#step-4';
    }

    clearSlide4Scroll() {
        this.setState({ goToSlide4: false })
    }

    getStepStyling(stepNum) {
        if (this.state.step === stepNum) {
            return "active"
        }
    }

    setFormState(value) {
        this.setState({ formValues: value })
    }

    setStepHandler(num) {
        if (num === undefined) {
            return
        }
        this.setState({ step: num });
    }

    removePtags(textFromServer) {
        if (textFromServer.slice(0, 3) == "<p>") {
            return textFromServer.substr(3, textFromServer.length - 7)
        }
        return textFromServer;
    }

    sanitizeHTML(dirtyHTML){
        return DOMPurify.sanitize(dirtyHTML, { ADD_ATTR: ['target']})
    }

    mainNavOffsetHandler() {
        if (window.pageYOffset || document.documentElement.scrollTop) {
            document.body.classList.remove('is-top');
        } else {
            document.body.classList.add('is-top');
        }
    }

    custScrollTo(element) {     
        element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }


    render() {
        const tickSVG = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e %3csvg width='12px' height='12px' viewBox='0 0 12 12' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3ctitle%3e6B537FDF-5163-4F55-9CE8-0FC7B0450613%3c/title%3e%3cg id='Home' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e%3cg id='1920-Desktop-(1600)---Input-dropdown-open' transform='translate(-241.000000%2c -279.000000)'%3e%3cg id='Group' transform='translate(235.000000%2c 185.000000)'%3e%3cg id='stepper/increment/large-copy-2' transform='translate(0.000000%2c 88.000000)'%3e%3cg id='done_black_24dp' transform='translate(6.000000%2c 6.000000)'%3e%3cpolygon id='Path' points='0 0 12 0 12 12 0 12'%3e%3c/polygon%3e%3cpolygon id='Path' fill='%23B2B2B4' fill-rule='nonzero' points='4.5 8.1 2.4 6 1.7 6.7 4.5 9.5 10.5 3.5 9.8 2.8'%3e%3c/polygon%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e";
        return (
            <div className={'pres-calc-journey-' + this.journey}>
                {!this.state.loading &&
                    <div className="pres-calc-nav" id="slider-nav">

                        <div data-menuanchor="step-1" className={"pres-calc-nav__step " + this.getStepStyling(1)} >
                            <a onClick={() => this.toggleSlide(1, true)}>
                                <span className="step-num">{this.state.step > 1 ? <img src={tickSVG} alt="Check mark" /> : "1"}</span>
                                <span className="step-txt">
                                    <span>Getting<br />started</span>
                                </span>
                            </a>
                        </div>


                        {this.journey === 1 &&
                            <div data-menuanchor="step-2" className={"pres-calc-nav__step " + this.getStepStyling(2)}>
                                <a onClick={() => this.toggleSlide(2, true)}>
                                    <span className="step-num">{this.state.step > 2 ? <img src={tickSVG} alt="Check mark" /> : "2"}</span>
                                    <span className="step-txt">
                                        <span>overview of<br />your options</span>
                                    </span>
                                </a>
                            </div>
                        }


                        <div data-menuanchor="step-3" className={"pres-calc-nav__step " + this.getStepStyling(3)}>
                            <a onClick={() => this.toggleSlide(3, true)}>
                                <span className="step-num">{this.state.step > 3 ? <img src={tickSVG} alt="Check mark" /> : this.journey === 1 ? "3" : "2"}</span>
                                <span className="step-txt">
                                    <span>Your<br />situation</span>
                                </span>
                            </a>
                        </div>

                        <div data-menuanchor="step-4" className={"pres-calc-nav__step " + this.getStepStyling(4)}>
                            <a onClick={() => this.toggleSlide(4, true)}>
                                <span className="step-num">{this.state.step > 4 ? <img src={tickSVG} alt="Check mark" /> : this.journey === 1 ? "4" : "3"}</span>
                                <span className="step-txt">
                                    <span>Your<br />results</span>
                                </span>
                            </a>
                        </div>

                        <div data-menuanchor="step-5" className={"pres-calc-nav__step " + this.getStepStyling(5)}>
                            <a onClick={() => this.toggleSlide(5, true)}>
                                <span className="step-num">{this.state.step > 5 ? <img src={tickSVG} alt="Check mark" /> : this.journey === 1 ? "5" : "4"}</span>
                                <span className="step-txt">
                                    <span>CHOOSE YOUR<br />OPTION</span>
                                </span>
                            </a>
                        </div>
                    </div>
                }
                {!this.state.loading && this.state.step > 0 && <Slide1
                    data={this.state.data}
                    journey={this.journey}
                    removePtags={(text) => this.removePtags(text)}
                    sanitizeHTML = {(html) => this.sanitizeHTML(html)}
                    openNextSlide={() => this.journey === 1 ? this.toggleSlide(2) : this.toggleSlide(3)} // skip slide 2 if savings journey
                    custScrollTo={(el) => this.custScrollTo(el)}
                    recordAnalytics={(e) => this.recordAnalytics(e)}
                />}
                {!this.state.loading && this.journey === 1 && this.state.step > 1 && <Slide2
                    data={this.state.data}
                    journey={this.journey}    
                    sanitizeHTML = {(html) => this.sanitizeHTML(html)}            
                    closeSlide={() => this.toggleSlide(1)}
                    openNextSlide={() => this.toggleSlide(3)}
                    custScrollTo={(el) => this.custScrollTo(el)}
                    recordAnalytics={(e) => this.recordAnalytics(e)}
                />}
                {!this.state.loading && this.state.step > 2 && <Slide3
                    data={this.state.data}
                    journey={this.journey}
                    sanitizeHTML = {(html) => this.sanitizeHTML(html)}
                    closeSlide={() => this.journey === 1 ? this.toggleSlide(2) : this.toggleSlide(1)} // return to slide 1 if savings journey
                    openNextSlide={() => this.toggleSlide(4)}
                    setFormValues={(value) => this.setFormState(value)}
                    custScrollTo={(el) => this.custScrollTo(el)}
                    recordAnalytics={(e) => this.recordAnalytics(e)}
                    setStepHandler={(num) => this.setStepHandler(num)}
                />}
                {!this.state.loading && this.state.step > 3 && <Slide4
                    data={this.state.data}
                    journey={this.journey}
                    sanitizeHTML = {(html) => this.sanitizeHTML(html)}
                    goToSlide4={this.state.goToSlide4}
                    clearSlide4Scroll={() => clearSlide4Scroll()}
                    closeSlide={() => this.toggleSlide(3)}
                    openNextSlide={() => this.toggleSlide(5.2)}
                    formData={this.state.formValues}
                    custScrollTo={(el) => this.custScrollTo(el)}
                    recordAnalytics={(e) => this.recordAnalytics(e)}
                />}
                {!this.state.loading && this.state.step > 4 && <Slide5
                    data={this.state.data}
                    journey={this.journey}
                    removePtags={(text) => this.removePtags(text)}     
                    sanitizeHTML = {(html) => this.sanitizeHTML(html)}      
                    closeSlide={() => this.toggleSlide(4)}
                    goToSlide4={() => this.goToSlide4()}
                    toggleTab={(value) => this.toggleSlide(value)}
                    custScrollTo={(el) => this.custScrollTo(el)}
                    recordAnalytics={(e) => this.recordAnalytics(e)}
                />}
            </div>
        )
    }
}

let domContainer = document.querySelector('#preservation-calculator');
const root = createRoot(domContainer);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);